import { RefObject, useEffect, useRef } from "react";

// Closes a menu when the user clicks outside it or presses Escape.
// Escape asks for focus back, so keyboard users don't lose their place.
export default function useDismiss(
  refs: RefObject<HTMLElement>[],
  isOpen: boolean,
  onClose: (returnFocus: boolean) => void
) {
  const latest = useRef({ refs, onClose });
  latest.current = { refs, onClose };

  useEffect(() => {
    if (!isOpen) return;

    const closeOnOutsideClick = (e: MouseEvent) => {
      const target = e.target as Node;
      if (!latest.current.refs.some((ref) => ref.current?.contains(target))) latest.current.onClose(false);
    };
    const closeOnEscape = (e: KeyboardEvent) => {
      if (e.key !== "Escape") return;
      e.preventDefault();
      latest.current.onClose(true);
    };

    document.addEventListener("mousedown", closeOnOutsideClick);
    document.addEventListener("keydown", closeOnEscape);
    return () => {
      document.removeEventListener("mousedown", closeOnOutsideClick);
      document.removeEventListener("keydown", closeOnEscape);
    };
  }, [isOpen]);
}
